import { InjectionToken } from '@angular/core';

/** O `cardapio.json` como o CDN o entrega: o hash que o app compara e o cardápio em si. */
export interface EnvelopeDoCardapio {
    hash: string;
    cardapio: any;
}

/** O cardápio que quem renderiza já baixou, e de qual loja ele é. */
export interface CardapioDoRender {
    slug: string;
    envelope: EnvelopeDoCardapio;
}

/**
 * O cardápio entregue pronto ao render do servidor, em vez de o app baixá-lo sozinho.
 *
 * Quem provê é o `renderizarCardapio()` do `main.server.ts`, chamado pela Lambda de render e pelo
 * render de fumaça do deploy. A Lambda grava na página o ETag do `cardapio.json` que baixou, e o
 * porteiro compara esse ETag com o do S3 a cada visita para saber se a página ainda vale. Se o app
 * baixasse o cardápio de novo, uma gravação entre os dois downloads deixaria a página com o
 * conteúdo novo e o ETag velho, ou o contrário. Com o cardápio injetado, os dois vêm do mesmo
 * download.
 */
export const CARDAPIO_DO_RENDER = new InjectionToken<CardapioDoRender>('CARDAPIO_DO_RENDER');
